<template>
  <div class="container-fluid closingQuestions padding-left-0px">
    <div class="closingQuestions">
      <div class="row padding-4px">
        <div class="col-md-12 col-lg-12">
          <div class="font-size-19px create-lesson-input-text-style col-md-12 col-lg-12">
            Closing Questions
            <div class="tooltip1">
              <img :src="copyicon" alt="iconCopy" class="height-20Px width-20Px padding-bottom-3px img-opacity cursor-pointer" @click="copyExistingOpeningQuestions" v-if="getOpeningQuestionListValue.length > 0">
              <span class="tooltiptext">Copy Opening Questions</span> 
            </div>
          </div>  
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-12 padding-bottom-15px">
          <div class="create-lesson-input-text-style col-md-2 col-lg-2">
          </div>
          <div class="create-lesson-input-text-style col-md-4 col-lg-4">
            <span class="font-size-14px glyphicon glyphicon-plus-sign margin-left-10px font-size-17px cursor-pointer" @click="openCreateMissionSubElement($event,'MCQ')"></span>
            <span class="font-size-14px cursor-pointer" @click="openCreateMissionSubElement($event,'MCQ')">Mcq</span>
          </div>
          <div class="create-lesson-input-text-style col-md-4 col-lg-4">
            <span class="font-size-14px glyphicon glyphicon-plus-sign margin-left-10px font-size-17px cursor-pointer" @click="openCreateMissionSubElement($event,'RD')"></span>
            <span class="font-size-14px cursor-pointer" @click="openCreateMissionSubElement($event,'RD')">Reflection</span>
          </div>
          <div class="create-lesson-input-text-style col-md-2 col-lg-2">
          </div>
        </div>
        <!-- <hr class="border-1px"> -->
      </div>
      <div class="row padding-bottom-20px">
        <div class="container-fluid">
          <div class="col-md-12 col-lg-12 border-bottom-1px">
          </div>
        </div>
      </div>
      <mission-create-mcq-element v-if="showMissionMcqOverlay" :lessonObj="getParentLessonObj" :MissionGameResp="getMissionGameResp" @openOverlay="updateCloseMcqOverlayValue" :isOpeningQuestion="false"></mission-create-mcq-element>
      <mission-create-rd-element v-if="showMissionRDOverlay" :lessonObj="getParentLessonObj" :MissionGameResp="getMissionGameResp" @openOverlay="updateCloseRDOverlayValue" :isOpeningQuestion="false"></mission-create-rd-element>
      <mission-closing-question-list :overallClosingQuestionList="getoverallClosingQuestionList" :lessonObj="getParentLessonObj" :missionGameResp="getMissionGameResp" @updateOverallList="updatedOverallList" :isOpeningQuestion="false"></mission-closing-question-list>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="copyOpeningQuestions"></confirmation-alert>
    </div>
  </div>
</template>

<script>
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import Loader from '@/components/dashboard/Loader'
import AlertBox from '@/components/AlertOverlay'
import MissionClosingQuestionList from '@/components/mission_game/MissionClosingQuestionList'
import MissionCreateMCQElement from '@/components/mission_game/MissionCreateMCQElement'
import MissionCreateRDElement from '@/components/mission_game/MissionCreateRDElement'
import copyIcon from '../../assets/images/copyicon.svg'
import { elementService } from '@/server-util/element-service'
import { constants } from '@/utils/constants'
import filter from 'lodash/filter'
export default {
  props: ['lessonObj', 'MissionGameResp', 'openingQuestionList'],
  data: function () {
    return {
      showConfirmationBox: false,
      prefixString: '',
      postDeleteMcqString: '',
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      overallClosingQuestionList: [],
      showMissionMcqOverlay: false,
      showMissionRDOverlay: false,
      copyicon: copyIcon
    }
  },
  name: 'closingQuestions',
  methods: {
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    copyOpeningQuestions (value) {
      this.showConfirmationBox = false
      var _this = this
      var storeObj = this.$store
      if (value) {
        if (
          this.getMissionGameResp !== undefined
        ) {
          this.$store.state.isLoading = true
          elementService
            .copyOpeningQuestion(storeObj.state.access_token, _this.getMissionGameResp.ElementId)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                _this.getAllElementsOfCurrentMission()
              } else {
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            }, errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Selected getMissionGameResp Object is NULL hence declined COPY OPENING QUESTION OPERATION'
          )
        }
      }
    },
    getAllElementsOfCurrentMission () {
      var _this = this
      var storeObj = this.$store
      if (
        this.getMissionGameResp !== undefined
      ) {
        this.$store.state.isLoading = true
        elementService
          .listElements(storeObj.state.access_token, _this.getMissionGameResp.BonusModuleId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              var responseData = responseObj.data
              // console.log('responseData >>> ' + JSON.stringify(responseData))
              this.overallClosingQuestionList = filter(responseData, function (o) {
                return o.SubType !== constants.MissionQuestionType.Opening
              })
              // console.log('Copy this.overallClosingQuestionList >>> ' + JSON.stringify(this.overallClosingQuestionList))
              _this.$store.state.isLoading = false
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Selected getMissionGameResp Object is NULL hence declined ALL MISSION ELEMENTS OPERATION'
        )
      }
    },
    copyExistingOpeningQuestions: function () {
      this.showConfirmationBox = true
      this.prefixString = 'Are you sure you want to copy'
      this.postString = ' all opening question(s)?'
    },
    updatedOverallList (value) {
      // console.log('Updated Opening List >>> ' + JSON.stringify(value))
      this.overallClosingQuestionList = value
    },
    updateCloseMcqOverlayValue (value) {
      this.showMissionMcqOverlay = !value.closeOverlay
      if (value.currentResponseObj !== null && value.currentResponseObj.currentResponseObj !== 'null' && value.currentResponseObj.currentResponseObj !== '') {
        this.overallClosingQuestionList.push(value.currentResponseObj)
      }
      var objToPass = {
        lessonObj: this.getParentLessonObj,
        MissionGameResp: this.getMissionGameResp,
        closeOverlay: false,
        overallClosingQuestionList: this.getoverallClosingQuestionList
      }
      this.$emit('HideMainMissionOverlay', objToPass)
    },
    updateCloseRDOverlayValue (value) {
      this.showMissionRDOverlay = !value.closeOverlay
      if (value.currentResponseObj !== null && value.currentResponseObj.currentResponseObj !== 'null' && value.currentResponseObj.currentResponseObj !== '') {
        this.overallClosingQuestionList.push(value.currentResponseObj)
      }
      var objToPass = {
        lessonObj: this.getParentLessonObj,
        MissionGameResp: this.getMissionGameResp,
        closeOverlay: false,
        overallClosingQuestionList: this.getoverallClosingQuestionList
      }
      this.$emit('HideMainMissionOverlay', objToPass)
    },
    openCreateMissionSubElement: function (event, selectedOption) {
      switch (selectedOption) {
        case 'MCQ':
          this.showMissionMcqOverlay = true
          var objToPass = {
            lessonObj: this.getParentLessonObj,
            MissionGameResp: this.getMissionGameResp,
            closeOverlay: true,
            overallClosingQuestionList: this.getoverallClosingQuestionList
          }
          this.$emit('HideMainMissionOverlay', objToPass)
          break
        case 'RD':
          this.showMissionRDOverlay = true
          objToPass = {
            lessonObj: this.getParentLessonObj,
            missionGameResp: this.getMissionGameResp,
            closeOverlay: true,
            overallClosingQuestionList: this.getoverallClosingQuestionList
          }
          this.$emit('HideMainMissionOverlay', objToPass)
          break
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of confirmation overlay
      this.showConfirmationBox = value
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'mission-closing-question-list': MissionClosingQuestionList,
    'mission-create-mcq-element': MissionCreateMCQElement,
    'mission-create-rd-element': MissionCreateRDElement,
    'confirmation-alert': ConfirmationOverlay
  },
  computed: {
    getOpeningQuestionListValue: {
      get: function () {
        return this.openingQuestionList
      }
    },
    getoverallClosingQuestionList: {
      get: function () {
        return this.overallClosingQuestionList
      }
    },
    getMissionGameResp: {
      get: function () {
        // console.log('Opening Questions >>> ' + JSON.stringify(this.MissionGameResp))
        return this.MissionGameResp
      }
    },
    getParentLessonObj: {
      get: function () {
        return this.lessonObj
      }
    }
  },
  watch: {
    getoverallClosingQuestionList: function (newValue, oldValue) {
      this.$emit('overallClosingQuestionList', newValue)
    }
  }
}
</script> 
<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-top-2Perc
{
	margin-top: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
    border:1px solid red;
}
.margin-bottom-2Perc {
    margin-bottom: 2%;
}
.font-size-19px {
    font-size: 19px;
}
.padding-right-6px {
    padding-right:6px; 
}
.padding-top-1Perc {
    padding-top:1%;
}
.padding-left-0px {
    padding-left:0px;
}
.margin-left-10px {
    margin-left: 10px;
}
.padding-4px {
  padding:4px;
}
.font-size-17px {
  font-size:17px;
}
.height-20Px {
 height:20px; 
}
.width-20Px {
  width:20px;
}
.padding-bottom-3px {
  padding-bottom:3px;
}
.font-size-14px {
    font-size: 14px !important;
}
.padding-bottom-15px {
  padding-bottom:15px;
}
hr { 
  display: block;
  /* margin-top: 0.5em; */
  /* margin-bottom: 0.5em; */
  margin-left: auto;
  margin-right: auto;
  /* border-style: inset; */
  width:90%;
}
.border-1px {
  border: 0.5px solid #aaa;
}
.tooltip1 {
    position: relative !important;
    display: inline-block !important;
    /* border-bottom: 1px dotted black !important; */
}
.tooltip1 .tooltiptext {
  visibility: hidden;
  width: 130px;
  background-color: #696969;
  /* opacity:0.8; */
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 5px 5px;
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  font-size: 10px;
}
.tooltip1:hover .tooltiptext {
  visibility: visible;
}
.margin-left-7px {
  margin-left:7px;
}
.margin-bottom-21px {
  margin-bottom:21px;
}
.border-bottom-1px {
  border-bottom: 0.5px solid #aaa;
}
.padding-bottom-20px {
  padding-bottom:20px;
}
.padding-top-15px {
  padding-top:15px;
}
</style>


// WEBPACK FOOTER //
// src/components/mission_game/ClosingQuestions.vue